import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const accommodationAvailableAddonEntity: Entity = {
  model: model,
  repository: repository,
}

export default accommodationAvailableAddonEntity
